import url from '@/utils/config';
import styles from './NuroAppBanner.module.css';

const stores = [
  {
    name: 'App Store',
    desktopHref: 'https://apps.apple.com/jp/app/id1518953646?pt=405568&ct=myp_PC&mt=8',
    mobileHref: 'https://apps.apple.com/jp/app/id1518953646?pt=405568&ct=myp_SP&mt=8',
    desktopImage: '/images/btn_appstore_pc.png',
    mobileImage: '/images/btn_appstore_sp.png',
    className: styles.ios,
  },
  {
    name: 'Google Play',
    desktopHref:
      'https://play.google.com/store/apps/details?id=jp.nuro&referrer=utm_source%3Dnuro%26utm_medium%3Dweb%26utm_campaign%3Dmyp_PC',
    mobileHref:
      'https://play.google.com/store/apps/details?id=jp.nuro&referrer=utm_source%3Dnuro%26utm_medium%3Dweb%26utm_campaign%3Dmyp_SP',
    desktopImage: '/images/btn_googleplay_pc.png',
    mobileImage: '/images/btn_googleplay_sp.png',
    className: styles.android,
  },
];

const NuroAppBanner = () => (
  <section className={styles.banner} aria-label='NURO光アプリ'>
    <picture>
      <source
        media='(max-width: 640px)'
        srcSet={url('/images/bnr_nuroApp_mobile.png')}
        width='690'
        height='334'
      />
      <img
        className={styles.background}
        src={url('/images/bnr_nuroApp_desktop.png')}
        width='1840'
        height='642'
        alt='NURO光アプリで、毎月の確認＆限定特典をチェック！'
      />
    </picture>
    <div className={styles.stores}>
      {stores.map(({ name, desktopHref, mobileHref, desktopImage, mobileImage, className }) => (
        <div className={className} key={name}>
          <a
            className={styles.desktopLink}
            href={desktopHref}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`${name}でNURO光アプリを入手`}
          >
            <img src={url(desktopImage)} alt='' />
          </a>
          <a
            className={styles.mobileLink}
            href={mobileHref}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`${name}でNURO光アプリを入手`}
          >
            <img src={url(mobileImage)} alt='' />
          </a>
        </div>
      ))}
    </div>
  </section>
);

export default NuroAppBanner;
